import { gql } from '@zenbusiness/application-commons-graphql';

export const ENABLE_MFA_MUTATION = gql`
  mutation enableMFA {
    enableMFA {
      success
    }
  }
`;
